module.exports = __webpack_public_path__ + "img/set-equipment.9a126774.png";